import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/(public)/previewquote/$id')({
  component: PreviewQuotePage,
});

function PreviewQuotePage() {
  return <div>TODO: Quote Preview</div>;
}
